import React from 'react';
import { SearchBox } from './view/searchBox';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SearchBox', 
  itemElt: (item, cmsOption) => <SearchBox item={item} cmsOption={cmsOption} />
}